module.exports = __webpack_public_path__ + "static/media/cop.ada3c508.png";